var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slice',[_c('figure',{staticClass:"slice-visual"},[_c('b-img',{class:_vm.edges,attrs:{"alt":_vm.slice.primary.visual.alt,"src":_vm.slice.primary.visual.url}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }